// src/components/NotifModalShell.tsx
import React from 'react';
import { Modal, Space } from 'antd';

type Props = {
  title: React.ReactNode;
  open: boolean;
  onClose: () => void;
  /** ширина модалки (по умолчанию 980 как у заказов) */
  width?: number;

  /** левая группа кнопок в шапке (например «Отметить прочитанными», «Отметить всё…») */
  leftControls?: React.ReactNode;
  /** правая группа (например «Удалить выбранные») */
  rightControls?: React.ReactNode;

  /** основной контент (обычно таблица) */
  children: React.ReactNode;

  /** подсказка/хинт под таблицей */
  hint?: React.ReactNode;
};

const NotifModalShell: React.FC<Props> = ({
  title,
  open,
  onClose,
  width = 980,
  leftControls,
  rightControls,
  children,
  hint,
}) => {
  return (
    <Modal
      title={title}
      open={open}
      onCancel={onClose}
      footer={null}
      width={width}
      destroyOnHidden
    >
      {(leftControls || rightControls) && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 8,
            marginBottom: 12,
          }}
        >
          <Space wrap>{leftControls}</Space>
          <Space wrap>{rightControls}</Space>
        </div>
      )}

      {children}

      {hint ? <div style={{ marginTop: 8 }}>{hint}</div> : null}
    </Modal>
  );
};

export default NotifModalShell;
